export default "__VITE_ASSET__376931a4__"